//@ts-nocheck
//NOTE - firstname, hotel, startDate, endDate, countLead, adults, kids, ages, priceName, room, priceCount
export default function (values, template) {
    const { firstName, room, checkIn, checkOut, night, adults, price, ages, typePrice, siteName, siteEmail, rooms, message } = values;
    let agesKids = '';
    if (ages) {
        let agesArr = ages.split(",");
        for (let i = 0; i < agesArr.length; i++) {
            agesKids += `<li>Ребенок ${i + 1}: <strong>${agesArr[i]} лет</strong></li>`;
        }
    }

    const html = `
      <table align="center" border="0" cellpadding="0" cellspacing="0" width="500" style="font-family: Arial, sans-serif; color: #153643; font-size: 15px; line-height: 20px;">
        <tr>
          <td style="padding: 20px;">
            <h2 style="color: #333; margin-bottom: 15px;">Спасибо за ваш выбор!</h2>
            ${firstName ? `<p>Уважаемый(ая) ${firstName},</p>` : ''}
            ${siteName ? `<p>Ваш запрос расчёта стоимости отдыха в ${siteName} <strong>успешно отправлен</strong>.</p>` : ''}
            <h3 style="margin: 30px 0 15px; font-weight: 700;">Детали запроса:</h3>
            <ul style="margin: 0 0 20px 20px; padding: 0;">
              ${checkIn ? `<li>Заезд: <strong>${checkIn}</strong></li>` : ''}
              ${checkOut ? `<li>Выезд: <strong>${checkOut}</strong></li>` : ''}
              ${adults ? `<li>Взрослых: <strong>${adults}</strong></li>` : ''}
              ${agesKids ? agesKids : ''}
              ${rooms ? `<li>Количество номеров: <strong>${rooms}</strong></li>` : ''}
              ${message ? `<li>Примечание: <span style="color: #555;">${message}</span></li>` : ''}
            </ul>
            <p>Ожидайте расчёт стоимости от специалиста отдела бронирования <strong>в течение рабочего дня</strong>.</p>
            <p>Если у вас остались вопросы или вы хотите изменить данные запроса, <strong>звоните</strong>:</p>
            <p>
              <strong><a href="tel:+78005113515" style="color: #005555; text-decoration: none;">+7 (800) 511-35-15</a></strong> (бесплатно),<br />
              <strong><a href="tel:+79784101030" style="color: #005555; text-decoration: none;">+7 978 410-10-30</a></strong> (Telegram, WhatsApp).
            </p>
            ${siteEmail ? `<p>или пишите нам на почту: <strong><a href="mailto:${siteEmail}" style="color: #005555; text-decoration: none;">${siteEmail}</a></strong></p>` : ''}
            <p style="margin-top: 20px;">С наилучшими пожеланиями,<br />отдел бронирования</p>
          </td>
        </tr>
      </table>
    `;
    return html;
}